<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" persistent width="600px">
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Пост</v-toolbar-title>
                    <EventButtonsInFooter
                            :messageModel="postModel"
                            :visibleButtons="{chainBlock: 0, moduleBlock: 0, findWordBlock: 0, visKeyboardForm: 0}"
                            @visAttachmentForm="visAttachmentForm=true"
                            @jumpInfoDialog="jumpInfoDialog=true"
                            v-if="edit === true"
                    ></EventButtonsInFooter>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="copyPost">
                            <v-icon>file_copy</v-icon>
                            Копия
                        </v-btn>
                        <v-btn dark text @click="saveValue" v-if="edit || !edit" :disabled="!this.valid">
                            <v-icon>save</v-icon>
                            {{postModel.id === null ? ' Создать' : ' Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list subheader class="content">
                    <v-container>
                        <v-form
                                ref="form"
                                v-model="valid"
                        >
                            <v-row class="d-flex">
                                <v-col cols="8" md12 class="py-0">
                                    <v-text-field
                                            v-model="postModel.title"
                                            :counter="35"
                                            label="Название поста"
                                            :readonly="!edit"
                                            class="ma-2 pa-2"
                                            :rules="[rules.required, rules.maxLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4" md12 class="py-0">
                                    <!--<span>Статус: <span :class="postStatusColor">{{postStatus}}</span></span>-->
                                    <v-select
                                            :items="[{ value: 1, text: 'В работе'}, { value: 2, text: 'Опубликован'}, { value: 3, text: 'Ошибки'}]"
                                            v-model="postModel.status"
                                            label="Статус"
                                            :readonly="!edit ? false : false"
                                            class="ma-2 pa-2 my-0 py-0"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-textarea
                                            auto-grow
                                            rows="1"
                                            name="input-7-1"
                                            :counter="700"
                                            v-model="postModel.text"
                                            label="Текст"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 my-0 py-0"
                                            :rules="[rules.maxLengthText]"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="7" md12 class="py-0 px-7">
                                    <span>Платформа: </span>
                                    <v-btn-toggle v-model="postModel.platform" mandatory>
                                        <v-btn text value="vk" small :disabled="!edit">
                                            Вконтакте
                                        </v-btn>
                                        <v-btn text value="tg" small :disabled="!edit">
                                            Телеграм
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-text-field
                                            v-model="postModel.post_id"
                                            label="ID опубликованного или отложенного поста"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 my-0 py-0"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md12 class="py-0">
                                    <v-switch
                                            v-model="postModel.pending"
                                            label="Отложенный пост"
                                            :text-true="1"
                                            :text-false="0"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 my-0 py-0"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-select
                                            :items="events"
                                            v-model="postModel.event_id"
                                            label="Событие в которое записать ID опубликованного поста"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 my-0 py-0"
                                            item-text="title"
                                            item-value="id"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <media-library-block
                                            :attachments="attachments"
                                    >
                                    </media-library-block>
                                </v-col>
                                <v-col cols="4" md4 class="py-0 pl-7">
                                    <v-text-field
                                            prepend-icon="access_time"
                                            label="Задать время"
                                            :value="formattedTime"
                                            @input="changeTime"
                                            type="time"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" md6 class="py-0 pl-4">
                                    <v-menu
                                            ref="menu"
                                            v-model="isActive"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    :value="formattedDate"
                                                    label="Задать дату"
                                                    v-on="on"
                                                    readonly
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                color="blue lighten-3"
                                                :value="formattedDatePicker"
                                                @input="changeDate"
                                                show-current
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="3"></v-col>
                                <v-col cols="5" class="pl-7">
                                    <v-btn
                                            @click="powerLikeControl"
                                    ><span class="text-none caption">{{likeControlButtonTitle}}</span></v-btn>
                                </v-col>
                                <v-col cols="3" md4 class="py-0" title="Задать время контроля лайков">
                                    <v-text-field
                                            prepend-icon="access_time"
                                            label="Задать время контроля лайков"
                                            :value="formattedTimeLike"
                                            @input="changeTimeLike"
                                            type="time"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" md6 class="py-0 pl-4" title="Задать дату контроля лайков">
                                    <v-menu
                                            ref="menu"
                                            v-model="isActiveLike"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            :disabled="!edit"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    :value="formattedDateLike"
                                                    label="Задать дату контроля лайков"
                                                    v-on="on"
                                                    readonly
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                color="blue lighten-3"
                                                :value="formattedDatePickerLike"
                                                @input="changeDateLike"
                                                show-current
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="5" v-show="postModel.like_control_time !== 0">
                                    <v-select
                                            :items="allVariables"
                                            v-model="postModel.other_params.variableId"
                                            label="Переменная отвечающая за контроль лайка в этом посте"
                                            class="ma-2 pa-2 my-0 py-0"
                                            item-text="title"
                                            item-value="id"
                                    ></v-select>
                                </v-col>
                                <v-col cols="7" v-show="postModel.like_control_time !== 0">
                                    <v-select
                                            :items="messages"
                                            v-model="postModel.other_params.messageId"
                                            label="Сообщение если человек лайкнул пост"
                                            class="ma-2 pa-2 my-0 py-0"
                                            item-text="title"
                                            item-value="id"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6" v-show="postModel.like_control_time !== 0">
                                    <v-text-field
                                            v-model="postModel.other_params.value"
                                            label="Значение переменной до лайка"
                                            class="ma-2 pa-2 my-0 py-0"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" v-show="postModel.like_control_time !== 0">
                                    <v-text-field
                                            v-model="postModel.other_params.setValue"
                                            label="Значение переменной после лайка"
                                            class="ma-2 pa-2 my-0 py-0"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-select
                                            title="Переменная в которую запишется id опубликованного поста"
                                            :items="allVariables"
                                            v-model="postModel.other_params.postIdToVariable"
                                            label="Переменная в которую запишется id поста"
                                            class="ma-2 pa-2 my-0 py-0"
                                            item-text="title"
                                            item-value="id"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6">
                                    <v-combobox
                                            title="Перечисление глобальных переменных"
                                            v-model="selectedVariables"
                                            :items="globalVariables"
                                            chips
                                            label="Глобальные переменные"
                                            multiple
                                            clearable
                                            persistent-hint
                                            item-text="title"
                                            item-value="id"
                                            hide-selected
                                            hide-details

                                    >
                                        <!--@input="changeGroups"-->
                                        <template v-slot:selection="{ index, item }">
                                            <v-chip
                                                    :key="index"
                                                    close
                                                    @click:close="removeItem(index)"
                                            >
                                                {{ item.title }}
                                            </v-chip>
                                        </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                            title="Значение на которое изменится переменная"
                                            v-model="postModel.other_params.changeGlobalVariables.function"
                                            label="Изменение на значение"
                                            class="ma-2 pa-2 my-0 py-0"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <attachment-form :visible="visAttachmentForm"
                         :messageModel="postModel" @close="visAttachmentForm=false"
                         @updateAttachment="updateAttachment"
        ></attachment-form>
        <jump-info-dialog :visible="jumpInfoDialog"
                          :model="postModel"
                          :type="2"
                          @close="jumpInfoDialog=false"
        ></jump-info-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import MediaLibraryBlock from '../../message/MediaLibraryBlock'
import AttachmentForm from '../../message/AttachmentForm'
import EventButtonsInFooter from '../../event/EventButtonsInFooter'
import JumpInfoDialog from '../../jump/JumpInfoDialog'
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
    name: 'PostForm',
    props: ['index', 'dialog', 'edit'],

    components: {
        MediaLibraryBlock,
        AttachmentForm,
        EventButtonsInFooter,
        JumpInfoDialog
    },
    data() {
        return {
            show: false,
            isActive: false,
            isActiveLike: false,
            postModel: {
                id: null,
                other_params: {
                    variableId: 0,
                    messageId: 0,
                    value: 1,
                    setValue: 2,
                    postIdToVariable: null,
                    changeGlobalVariables: {
                        variablesIds: [],
                        function: ''
                    }
                }
            },
            datePicker: '',
            theDate: new Date(),
            theDateLike: new Date(),
            attachments: [],
            visAttachmentForm: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            jumpInfoDialog: false,
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 35) || 'Максимальная длина названия 28 символов.',
                maxLengthText: value => (value === null || value.length <= 700) || 'Максимальная длина сообщения 500 символов.',
                maxLengthButton: value => (value.length <= 20) || 'Максимальная длина названия 20 символов.',
                urlValid: value => (value !== null ? !!value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9А-яЁё]+([\-\.]{1}[a-z0-9А-яЁё]+)*\.[a-zА-яЁё]{2,10}(:[0-9]{1,5})?(\/.*)?$/g) : false) || 'Ссылка имеет неверный формат. Пример верного формата https://app.chatway.ru/'
            },
            valid: false,
            selectedVariables: []
        }
    },
    methods: {
        saveValue() {
            this.postModel.post_time = Date.parse(this.theDate) / 1000
            this.postModel.like_control_time = Date.parse(this.theDateLike) / 1000
            let items = []
            this.selectedVariables.forEach(function(item) {
                items.push(item.id)
            })
            this.postModel.other_params.changeGlobalVariables.variablesIds = items
            this.$store.dispatch('posts/postCreate', this.postModel).then(response => {
                if (response.type === 'CreateResult' || response.type === 'UpdateResult') {
                    this.postModel.id = response.response.data.id
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Сохранение/создание прошло успешно!'
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Ошибка при сохранении/создании перехода'
                }
                this.snackbar = true
            })
        },
        copyPost() {
            this.postModel.id = null
            this.postModel.post_time = Date.parse(this.theDate) / 1000
            this.postModel.like_control_time = Date.parse(this.theDateLike) / 1000
            this.$store.dispatch('posts/postCreate', this.postModel).then(response => {
                if (response.type === 'CreateResult' || response.type === 'UpdateResult') {
                    this.postModel.id = response.response.data.id
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Сохранение/создание прошло успешно!'
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Ошибка при сохранении/создании перехода'
                }
                this.snackbar = true
            })
            this.show = false
        },
        loadModel(index = null) {
            if (index === null) {
                let postModel = Object.assign({}, this.postModelDef)
                postModel = JSON.parse(JSON.stringify(postModel))
                this.postModel = postModel
            } else {
                let postModel = Object.assign({}, this.posts[index])
                postModel = JSON.parse(JSON.stringify(postModel))
                if (postModel.other_params.hasOwnProperty('variable_id')) {
                    postModel.other_params.variableId = postModel.other_params.variable_id
                    delete postModel.other_params.variable_id
                }
                if (postModel.other_params.hasOwnProperty('message_id')) {
                    postModel.other_params.messageId = postModel.other_params.message_id
                    delete postModel.other_params.message_id
                }
                this.selectedVariables = [];
                for (let i = 0; i < postModel.other_params.changeGlobalVariables.variablesIds.length; i++) {
                    if (postModel.other_params.changeGlobalVariables.variablesIds[i] != null) {
                        let item = this.getVariableById(postModel.other_params.changeGlobalVariables.variablesIds[i])
                        if (item !== undefined) {
                            this.selectedVariables.push({ id: item.id, title: item.title })
                        }
                    }
                }
                this.postModel = JSON.parse(JSON.stringify(postModel))
                this.theDate = new Date(postModel.post_time * 1000)
                this.theDateLike = new Date(postModel.like_control_time * 1000)
            }
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        changeDate(date) {
            this.isActive = false
            date = new Date(date)
            date.setHours(this.theDate.getHours())
            date.setMinutes(this.theDate.getMinutes())
            this.theDate = date
        },
        changeTime(time) {
            this.isActive = false
            let date = new Date(this.theDate)
            date.setHours(time.split(':')[0])
            date.setMinutes(time.split(':')[1])
            this.theDate = date
        },
        changeDateLike(date) {
            this.isActiveLike = false
            date = new Date(date)
            date.setHours(this.theDateLike.getHours())
            date.setMinutes(this.theDateLike.getMinutes())
            this.theDateLike = date
            this.postModel.like_control_time = Date.parse(this.theDateLike) / 1000
        },
        changeTimeLike(time) {
            this.isActiveLike = false
            let date = new Date(this.theDateLike)
            date.setHours(time.split(':')[0])
            date.setMinutes(time.split(':')[1])
            this.theDateLike = date
            this.postModel.like_control_time = Date.parse(this.theDateLike) / 1000
        },
        selectKeyboard(keyboardId) {
            this.postModel.keyboard_id = keyboardId === 0 ? null : keyboardId
            this.saveValue()
        },
        removeKeyboard(index) {
            if (this.postModel.keyboard_id === this.keyboards[index].id) {
                this.postModel.keyboard_id = null
                this.saveValue()
            }
            this.keyboards.splice(index, 1)
        },
        updateAttachment(data) {
            this.attachments = data.selectedItems
            let attachments = data.selectedItems
            let ids = []
            for (let i = 0; i < attachments.length; i++) {
                ids.push(attachments[i].attachmentId)
            }
            if (data.saveMessage) {
                this.postModel.attachment = ids.join(',')
                this.saveValue() // сохранить сообщение
            }
        },
        sendTestMessage() {
            this.$store.dispatch('posts/sendTestMessage', this.postModel)
        },
        powerLikeControl() {
            this.theDateLike = new Date()
            this.theDateLike.setDate(this.theDateLike.getDate() + 1)
            this.postModel.like_control_time = this.postModel.like_control_time === 0 ? (Date.parse(this.theDateLike) + 86400) / 1000 : 0
        },
        removeItem(index) {
            this.selectedItems.splice(index, 1)
            this.changeItems()
        },
        changeItems() {
            let items = []
            this.selectedItems.forEach(function(item) {
                items.push(item.value)
            })
        }
    },
    watch: {
        dialog() {
            if (this.dialog === true) {
                this.loadModel(this.index)
                this.otherValid = !this.valid
                this.show = true
            } else {
                this.show = false
            }
        },
        show() {
            if (this.show === false) {
                this.postModel = Object.assign({}, this.postModelDef)
                this.$refs.form.resetValidation()
                this.theDate = new Date()
                this.theDateLike = new Date()
                this.$emit('close')
            }
        }
    },
    computed: {
        formattedDate() {
            return this.zero(this.theDate.getDate()) + '.' + this.zero((this.theDate.getMonth() + 1)) + '.' + this.theDate.getFullYear()
        },
        formattedDatePicker() {
            return this.theDate.getFullYear() + '-' + this.zero((this.theDate.getMonth() + 1)) + '-' + this.zero(this.theDate.getDate())
        },
        formattedTime() {
            return this.zero(this.theDate.getHours()) + ':' + this.zero((this.theDate.getMinutes()))
        },
        formattedDateLike() {
            return this.zero(this.theDateLike.getDate()) + '.' + this.zero((this.theDateLike.getMonth() + 1)) + '.' + this.theDateLike.getFullYear()
        },
        formattedDatePickerLike() {
            return this.theDateLike.getFullYear() + '-' + this.zero((this.theDateLike.getMonth() + 1)) + '-' + this.zero(this.theDateLike.getDate())
        },
        formattedTimeLike() {
            return this.zero(this.theDateLike.getHours()) + ':' + this.zero((this.theDateLike.getMinutes()))
        },
        globalVariables() {
            return this.$store.state.scenarios.variables.filter(variable => variable.form === 'global')
        },
        allVariables() {
            return this.$store.state.scenarios.variables
        },
        ...mapGetters({
            posts: 'posts/posts',
            // variables: 'scenarios/variables',
            getVariableById: 'scenarios/getVariableById',
            messages: 'messages/messages',
            postModelDef: 'posts/modelDefault'
        }),
        events() {
            let events = [{ title: 'Без записи в событие', id: null }]
            return events.concat(this.$store.getters['events/getEventsForPosts'])
        },
        postStatus() {
            return this.postModel.status === 1 ? 'В работе' : (this.postModel.status === 2 ? 'Опубликован' : 'Ошибки в публикации')
        },
        postStatusColor() {
            return this.postModel.status === 1 ? 'primary--text' : (this.postModel.status === 2 ? 'success--text' : 'red--text')
        },
        likeControlButtonTitle() {
            return this.postModel.like_control_time === 0 ? 'Включить контроль лайков' : 'Выключить контроль лайков'
        }
    },
    created() {
        this.$store.dispatch('events/eventAll', this.$route.params['pathMatch'])
        this.$store.dispatch('scenarios/variablesAll', this.$route.params['pathMatch'])
        this.$store.dispatch('messages/messageAll', this.$route.params['pathMatch'])
        this.$store.dispatch('posts/changeBotIdModelDefault', this.$route.params['pathMatch'])
        this.postModel = Object.assign({}, this.postModelDef)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
    .v-text-field {
        font-size: 0.9em;
    }
</style>
